import { FiCalendar } from 'react-icons/fi';

import Input from '@components/Input';

import { FieldRendererProps } from '../types';

const DateField = ({ field, disabled }: FieldRendererProps) => (
  <Input
    name={field.name}
    type="date"
    placeholder={field.placeholder || field.label}
    icon={FiCalendar}
    disabled={disabled}
    required={field.is_required}
  />
);

export default DateField;
